module.exports = __webpack_public_path__ + "src/assets/img/dilo_team_en.3061d762.svg";